import React from 'react'
import PropTypes from 'prop-types'
import PermittedConfirmModelAction
  from 'support/actions/PermittedConfirmModelAction'

export default function ChangeLinkStatus (props) {
  const { operation, status, label } = props

  return (
    <PermittedConfirmModelAction
      operation={operation} label={label}
      data={{ status: status }}
      confirmProps={{
        confirm: 'Fortsæt',
        cancel: 'Annuller'
      }}
    >
      <p>Er du sikker på du vil fortsætte?</p>
    </PermittedConfirmModelAction>
  )
}

ChangeLinkStatus.defaultProps = {
  operation: null,
  status: null,
  label: 'Change Status',
  data: {}
}

ChangeLinkStatus.propTypes = {
  operation: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
}
